module.exports = __webpack_public_path__ + "static/img/SPX.e555790.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/SPX.png
// module id = +Jmf
// module chunks = 1